import { Clear } from '@mui/icons-material'
import { Button, ButtonGroup } from '@mui/material'
import type { MediaGrid } from '../types'

export const Selected = ({ mediaGrid }: { mediaGrid: MediaGrid }) => {
  const selectedCount = mediaGrid.selectionModel.length

  return (
    <ButtonGroup
      disabled={selectedCount === 0}
      variant="text"
      color="info"
      sx={{ borderRadius: 0 }}
    >
      <Button sx={{ height: 56 }}>{selectedCount} Media Selected</Button>
      <Button
        sx={{ height: 56 }}
        onClick={() => mediaGrid.setSelectionModel([])}
      >
        <Clear fontSize="small" />
      </Button>
    </ButtonGroup>
  )
}
